import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, Switch} from 'react-router'
import createBrowserHistory from 'history/createBrowserHistory'
import AuthenticationFailed from 'dialogs/AuthenticationFailed';
import VPRekla from 'dialogs/VPRekla/Start';
import NewComplaint from 'dialogs/NewComplaint';
import ExtendComplaint from 'dialogs/ExtendComplaint';
import EditComplaint from 'dialogs/VPRekla/EditComplaint';
import BusinessLog from 'dialogs/VPRekla/EditComplaint/BusinessLog';
import Search from 'dialogs/VPRekla/Search';
import Admin from 'dialogs/VPRekla/Admin';
import FieldList from 'dialogs/VPRekla/Admin/FieldList';
import FailedArchiving from 'dialogs/VPRekla/FailedArchiving';
import Status from 'dialogs/Status';
import ErrorPage from 'dialogs/ErrorPage';
import ErrorBoundary from 'common/ErrorBoundary'

const getTitledComponent = (Component, title) => (props) => {
    return (
        <Component title={title} {...props} />
    );
};

const history = createBrowserHistory();
ReactDOM.render(
    <ErrorBoundary>
        <Router history={history}>
            <Switch>
                <Route path="/start" component={getTitledComponent(VPRekla, "VPRekla - Startseite")} />
                <Route path="/edit" component={getTitledComponent(EditComplaint, "VPRekla - Reklamation bearbeiten")} />
                <Route path="/businessLog" component={getTitledComponent(BusinessLog, "VPRekla - Vorgangsbericht")} />
                <Route path="/new" component={getTitledComponent(NewComplaint, "VPRekla - Reklamation erstellen")} />
                <Route path="/extend" component={getTitledComponent(ExtendComplaint, "VPRekla - Reklamation ergänzen")} />
                <Route path="/status" component={getTitledComponent(Status, "VPRekla - Reklamationsstatus")} />
                <Route path="/search" component={getTitledComponent(Search, "VPRekla - Reklamation suchen")} />
                <Route path="/admin" component={getTitledComponent(Admin, "VPRekla - Administration")} />
                <Route path="/fieldlist" component={getTitledComponent(FieldList, "VPRekla - Feldnamen-Übersicht")} />
                <Route path="/retryArchiving" component={getTitledComponent(FailedArchiving, "VPRekla - Fehler bei Archivierung")} />
                <Route path="/errorPage" component={getTitledComponent(ErrorPage, "VPRekla - Fehler")} />
                <Route path="/" component={getTitledComponent(AuthenticationFailed, "VPRekla - Fehler bei Anmeldung")} />
            </Switch>
        </Router>
    </ErrorBoundary>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js